var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},[_c('div',{staticClass:"social__wrapper"},[_c('Icon',{class:{
      "social__logo": true,
      "social__logo--without-margin": _vm.showName === false,
    },attrs:{"icon":_vm.code}}),(_vm.showName)?_c('span',{staticClass:"social__name"},[_vm._v(_vm._s(_vm.name))]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }